<template>
  <Card class="h-full flex flex-col">
    <CardHeader class="flex flex-row items-center justify-between p-4 border-b">
      <CardTitle>Styles</CardTitle>
      <Select v-model="currentFramework">
        <SelectTrigger class="w-[180px]">
          <SelectValue placeholder="CSS Framework" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="css">Vanilla CSS</SelectItem>
          <SelectItem value="tailwind">Tailwind CSS</SelectItem>
          <SelectItem value="scss">SCSS</SelectItem>
        </SelectContent>
      </Select>
    </CardHeader>
    <CardContent class="flex-1 p-0 overflow-hidden">
      <MonacoEditor
        v-model="styleCode"
        :language="currentFramework === 'scss' ? 'scss' : 'css'"
        :options="editorOptions"
        class="h-full"
      />
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { ref,watch } from 'vue'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import MonacoEditor from '@/components/ui/MonacoEditor.vue'

const props = defineProps<{
  modelValue: string
}>()

const emit = defineEmits(['update:modelValue'])

const styleCode = ref(props.modelValue)
const currentFramework = ref('css')
const editorOptions = {
  minimap: { enabled: false },
  fontSize: 14
}

watch(styleCode, (newVal) => {
  emit('update:modelValue', newVal)
})
</script>
